import { ViewPushChannelListener } from "../core/PushChannelListener.ts";

export class DesignerViewPushChannelListener extends ViewPushChannelListener {
  constructor(name?: string) {
    super(name ?? "<GenericDesignerPushChannelListener>");
  }

  static createInstance(): DesignerViewPushChannelListener {
    return new DesignerViewPushChannelListener();
  }
}
